import { faMapMarkerExclamation, faCartPlus } from '@fortawesome/pro-light-svg-icons';

export default [faMapMarkerExclamation, faCartPlus];
